import { GWPButton } from 'shared-components';
import EntertainerApplicationForm from './EntertainerApplicationForm';
import EntertainerShell from './EntertainerShell';
import useEntertainerApplicationContract from './useEntertainerApplicationContract';

export default function EntertainerApplication() {
	const { contract, error, retry } = useEntertainerApplicationContract();

	if (!contract) {
		return (
			<EntertainerShell compact>
				<section className="entertainer-result" aria-live="polite">
					<h1>{error ? 'We could not load the application' : 'Loading application'}</h1>
					<p>{error ?? 'Preparing the latest markets and application options…'}</p>
					{error ? <GWPButton onClick={retry}>Try again</GWPButton> : null}
				</section>
			</EntertainerShell>
		);
	}

	return (
		<EntertainerShell>
			<EntertainerApplicationForm contract={contract} />
		</EntertainerShell>
	);
}
